module.exports = __webpack_public_path__ + "static/media/pedra-deck-gaia.a1e6edd8.png";